// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.is-staging-banner {
  position: fixed;
  left: 0px;
  bottom: 0px;
  background-color: red;
  color: white;
  font-size: 1em;
  display: flex;
  flex-direction: row;
}
.is-staging-banner .isb-button:hover {
  background-color: green;
  color: white;
}
.isb-mini {
  font-size: 0.5em;
  background-color: red;
  color: white;
}

.isb-flex-col {
  display: flex;
  flex-direction: column;
}

.isb-button-smaller {
  font-size: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./src/StagingBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".is-staging-banner {\n  position: fixed;\n  left: 0px;\n  bottom: 0px;\n  background-color: red;\n  color: white;\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n}\n.is-staging-banner .isb-button:hover {\n  background-color: green;\n  color: white;\n}\n.isb-mini {\n  font-size: 0.5em;\n  background-color: red;\n  color: white;\n}\n\n.isb-flex-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.isb-button-smaller {\n  font-size: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
